import { AuthState } from './auth/auth.state';
import { CalendarState } from './calendar/state';
import { FeedState } from './feed/state';
import { CamerasState } from './cameras/state';
import { DashboardState } from './dashboard/state';
import { GameState } from './game/state';
import { HidesState } from './hides/state';
import { HuntingGroundState } from './hunting-ground/state';
import { HuntingSeasonsState } from './hunting-seasons/state';
import { InvitationsState } from './invitations/state';
import { MapState } from './map/state';
import { SidenavState } from './sidenav/sidenav.state';
import { StockCategoryState } from './stock-category/state';
import { StockFeedState } from './stock-feed/state';
import { StockLocationState } from './stock-location/state';
import { StockState } from './stock/state';
import { TagsState } from './tags/state';
import { TasksState } from './tasks/state';
import { WeatherState } from './weather/state';

export const appStates = [
  AuthState,
  CalendarState,
  FeedState,
  CamerasState,
  DashboardState,
  GameState,
  HidesState,
  HuntingGroundState,
  HuntingSeasonsState,
  InvitationsState,
  MapState,
  SidenavState,
  StockCategoryState,
  StockFeedState,
  StockLocationState,
  StockState,
  TagsState,
  TasksState,
  WeatherState,
];
